// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mermaid"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 17.5H21V21.0002H16V17.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 17.5H8V21.0002H3V17.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 6.50016H21V3H16V6.50016Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 6.50016H8V3H3V6.50016Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M9.50006 13.5002H14.5001V10H9.50006V13.5002Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 17.5V12H9.50006M18.5 17.5V12H14.5001M5.5 6.50016V13.5003M18.5 6.50016V13.5003M16 17.5H21V21.0002H16V17.5ZM3 17.5H8V21.0002H3V17.5ZM16 6.50016H21V3H16V6.50016ZM3 6.50016H8V3H3V6.50016ZM9.50006 13.5002H14.5001V10H9.50006V13.5002Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MermaidIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mermaid',
    ref,
    icon: element,
  },
));

MermaidIcon.displayName = 'MermaidIcon';

export default MermaidIcon;
